var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from 'react';
import classNames from 'classnames';
import { ObjectMode } from './object';
import { TreeSelect } from '@comall-backend-builder/components-basis';

var ObjectTreeNodeTreeMode = function (_super) {
  __extends(ObjectTreeNodeTreeMode, _super);

  function ObjectTreeNodeTreeMode() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * 单选时候的树形下拉框
   * @return {ReactElement}
   * @param value
   * @param displayInfo
   */


  ObjectTreeNodeTreeMode.prototype.getDisplayComponent = function (value, displayInfo) {
    if (!value) {
      return _super.prototype.getNotAvailableDisplayComponent.call(this, displayInfo);
    }

    var className = displayInfo.className;
    displayInfo = __assign(__assign({}, displayInfo), {
      className: classNames('type-object mode-object-tree-node-tree', className)
    });
    return _super.prototype.getAvailableDisplayComponent.call(this, value.name, displayInfo);
  };
  /**
   * 树形下拉框编辑模式，提供一个简单的数据转换来从原始值获取初始值
   * 因为是object类型，所以只应该是单选
   * @param controlInfo
   * @return {ReactElement}
   */


  ObjectTreeNodeTreeMode.prototype.getControlComponent = function (controlInfo) {
    var treeData = controlInfo.options;

    var treeSelectProps = __assign(__assign({}, controlInfo), {
      treeData: treeData,
      treeCheckable: false,
      multiple: false
    });

    return React.createElement(TreeSelect, __assign({}, treeSelectProps));
  };

  return ObjectTreeNodeTreeMode;
}(ObjectMode);

export { ObjectTreeNodeTreeMode };